<template>
    <div class="open-client dialog-wraper">
        <p><span v-t="'Opening'"></span> <a class="open-href" target="_blank" :href="url" v-t="'Install'"></a></p>
        <div class="dialog-foot">
            <el-button :loading="doing" @click="install" type="primary" size="mini" v-cloak v-t="'Install'"></el-button>
        </div>
    </div>
</template>

<script>
import { mapState,mapMutations,mapActions} from 'vuex';
export default {
    computed:{
        ...mapState([
            'smodule',
            'group',
            'confirmInfo',
            'action',
            'mutation',
            'dialogData'
        ]),
        ...mapState('index',[
            'doing'
        ]),
        url(){
            let ua = navigator.userAgent
            return /mac/i.test(ua) ? "https://itunes.apple.com/app/apple-store/id762263023?pt=19538800&ct=uscloud&mt=8" : /win/i.test(ua) ? "https://www.wps.com/download?from=webpreview" : ''
        }
    },
    methods:{
        ...mapActions([
            'close'
        ]),
        install(){
            window.open(this.url)
            this.close()
        }
    }
}
</script>

<style>
.open-href{
    white-space: pre;
}
</style>


// WEBPACK FOOTER //
// src/components/dialog/OpenClient.vue